(ns manage.content-variant-page.modal.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :modal.content-variants/open-renders-modal
  [(rf/inject-cofx :sub (fn [[_ {:keys [variant-ids]}]]
                          [:table.content-variants/pending-renders variant-ids]))
   (rf/inject-cofx :sub (fn [[_ {:keys [variant-ids]}]]
                          [:modal.content-variants/failure-causes variant-ids]))]
  (fn [{:table.content-variants/keys [pending-renders]
        :modal.content-variants/keys [failure-causes]}
       [_ {:keys [variant-ids action status]
           :or {status (if (empty? pending-renders) :failed :pending)}}]]
    {:fx [[:dispatch [:modal/open {:id :renders-modal
                                   :props {:variant-ids variant-ids
                                           :action action
                                           :status status
                                           :causes failure-causes}}]]]}))

(rf/reg-sub :modal.content-variants/failure-causes
  :<- [:resource.adset/has-templates?]
  :<- [:resource.feed-importers/field-content-mappings-configured?]
  (fn [[template? mappings?] [_ variant-ids]]
    (cond->> @(rf/subscribe [:table.content-variants/failed-renders variant-ids])
      true (map (fn [[_ renders]] (map #(get-in % [:job-result :cause]) renders)))
      true set
      (not template?) (#(conj % "No template has been uploaded"))
      (not mappings?) (#(conj % "No content columns have been mapped to placeholders")))))

(rf/reg-event-fx :modal.content-variants/open-selection-limit-modal
  (fn [_ [_ selection-limit]]
    {:fx [[:dispatch [:modal/open {:id :selection-limit-modal
                                   :props {:selection-limit selection-limit}}]]]}))
